import {HttpInterceptorFn, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {inject} from '@angular/core';
import {NotificationService} from './services/notification.service';

export const redirectInterceptor: HttpInterceptorFn = (req, next) => {
    const notificationService = inject(NotificationService);
    if (req.url.includes("api/login") || req.url.includes("api/datev/is-authenticated")) {
        return next(req);
    }
    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            const message = error.error?.message || error.message || 'Ein unerwarteter Fehler ist aufgetreten';
            notificationService.show(message, 'error');
            return throwError(() => error);
        })
    );
};